import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios_api } from "../../api";
import { IStoreState } from "../store.types";
import { LoadState } from "../../constants/enum";
import { ICommonState } from "./common.types";



export const fetchColumnsByTableNameAsync = createAsyncThunk<string[], { tableType: "VIEW" | "BASE TABLE", tableName: string, onCallback: (columns: string[]) => void }>(
    'common/fetchColumnsByTableNameAsync', async ({ tableType, tableName, onCallback }) => {
        const response = await axios_api.get(`/general/get-table-or-column-name?table_type=${tableType}&table_name=${tableName}`)
        const data = response.data.data;
        onCallback(data)
        return data
    },
)

export const fetchModuleAsync = createAsyncThunk<{ isView: boolean, data: string[] }, string>(
    'common/fetchModuleAsync', async (tableType, { getState, fulfillWithValue, rejectWithValue }) => {
        const isView = tableType === "VIEW";
        const state = getState() as IStoreState;
        const modules = state.common.modules;
        let isAlreadyFetched = isView
            ? modules.tableViews.loading === LoadState.succeeded
            : modules.tableNames.loading === LoadState.succeeded;

        if (isAlreadyFetched) {
            return rejectWithValue({ isView, data: [] }); // Prevent API call if already fetched
        }
        const response = await axios_api.get(`/general/get-table-or-column-name?table_type=${tableType}`)
        return fulfillWithValue({ isView, data: response.data.data })

    },
)




export const fetchEndpointsAsync = createAsyncThunk<ICommonState["endPointsByModule"]["data"], "post" | "get">(
    "common/fetchEndpointsAsync", async (method_type, { getState, rejectWithValue }) => {
        try {
            const state = getState() as IStoreState;
            const { loading } = state.common.endPointsByModule;
            if (loading === LoadState.succeeded) {
                return rejectWithValue("Already fetched"); // Prevent redundant API calls
            }

            const res = await axios_api.get(`/general/get-apis-endpoints?method_type=${method_type}`);
            return res.data.data; // ✅ Return the data directly
        } catch (err: any) {
            return rejectWithValue(err.response?.data?.message || "Failed to fetch endpoints");
        }
    }
);
